<template>
  <!--begin::Dashboard-->
  <div class="row">
    <div
      class="col-12 aos-init aos-animate content mx-auto"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <div class="titulo-pagina mb-10 text-lg-left text-sm-center">
        <span>DATOS </span
        ><span class="text-uppercase">CLIENTE</span>
      </div>
      <div class="card-femsa d-none d-sm-block">
        <div
          class="card-body row justify-content-between align-items-center py-6 px-8"
        >
          <div class="col-4 col-lg-4 d-none d-sm-block">
            <div class="card-femsa-titulo">NOMBRE EMPRESA</div>
            <div class="card-femsa-sub-titulo mt-4">
              {{ empresa.nombre }}
            </div>
          </div>
          <div class="col-12 col-lg-3 mt-5 mt-lg-0 total-deuda">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 border-right">
                <div
                  class="total-deuda-titulo text-uppercase font-weight-normal fs-15"
                >
                  DEUDA TOTAL
                </div>
                <div class="total-deuda-monto mt-1 fs-15">
                  {{ deudaTotal | currency }}
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center"
                >
                  Saldo disponible
                  <img
                    class="info-Img"
                    src="/media/img/infoImg.png"
                    data-toggle="tooltip"
                    title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."
                  />
                </div>
                <div class="total-deuda-monto mt-1 fs-15">
                  {{ saldoDisponible | currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-block d-sm-none total-deuda">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6 border-right">
            <div
              class="total-deuda-titulo text-uppercase font-weight-normal fs-15"
            >
              DEUDA TOTAL
            </div>
            <div class="total-deuda-monto mt-1 fs-15">
              {{ deudaTotal | currency }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <div
              class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center"
            >
              Saldo disponible
              <img
                class="info-Img"
                src="/media/img/infoImg.png"
                data-toggle="tooltip"
                title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."
              />
            </div>
            <div class="total-deuda-monto mt-1 fs-15">
              {{ saldoDisponible | currency }}
            </div>
          </div>
        </div>
      </div>

      <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
        <span>BÚSQUEDA </span><span>AVANZADA</span>
      </div>
      <div class="card-femsa mb-5 d-flex flex-row mb-4">
        <div
          class="card-body row justify-content-between align-items-center py-3 px-8"
        >
          <b-form
            action=""
            class="d-search d-flex justify-content-between align-items-end row"
            @submit.stop.prevent="onSubmit"
          >
            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
              <label for="inputDoc" class="label-femsa mb-2"
                >Nº Documento</label
              >
              <b-form-input
                class="form-control form-control-femsa"
                id="info-documento"
                name="documento"
                v-model="$v.form.documento.$model"
                :state="validateState('documento')"
                aria-describedby="info-documento-mensaje-validacion"
                placeholder="Nº documento"
                type="number"
              ></b-form-input>
            </div>
            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
              <label for="startDate" class="label-femsa mb-2">Periodo</label>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedDateFormattedMomentjs"
                    clearable
                    class="form-control v-input-femsa"
                    placeholder="dd/mm/aaaa"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="desde = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="desde"
                  @change="menu1 = false"
                  locale="es-cl"
                  :first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
              <label for="endDate" class="label-femsa mb-2"></label>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="computedDateFormattedMomentjs2"
                    clearable
                    class="form-control v-input-femsa"
                    placeholder="dd/mm/aaaa"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="hasta = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="hasta"
                  @change="menu2 = false"
                  locale="es-cl"
                  :first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
              <button
                class="btn-primary-femsa w-100"
                ref="kt_login_signin_submit"
              >
                Buscar
              </button>
            </div>
          </b-form>
        </div>
      </div>
      <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
        <span>PEDIDOS </span><span>PENDIENTES</span>
      </div>
      <div
        class="d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-center card-azul-femsa py-4 px-3 mb-7 row-gap-20"
      >
        <div class="checkbox mb-1 mt-1 ml-7">
          <label class="label-azul">
            <b-form-checkbox v-model="selectAll"
              >Seleccionar todos</b-form-checkbox
            >
          </label>
        </div>

        <div class="d-none d-sm-block">
          <download-excel
            class="btn-second-femsa w-200px d-flex justify-content-center cursor-pointer"
            :data="documents"
            :fields="json_fields"
            worksheet="Documentos"
            name="Documentos.xls"
          >
            Descargar
          </download-excel>
        </div>

        <div class="d-block d-sm-none w-100">
          <download-excel
            class="btn-second-femsa w-100 d-flex justify-content-center cursor-pointer"
            :data="documents"
            :fields="json_fields"
            worksheet="Pedidos"
            name="Pedidos.xls"
          >
            Descargar
          </download-excel>
        </div>
      </div>
      <b-overlay :show="loading" varant="white" rounded="sm">
        <template v-for="(item, i) in visiblePages" v-show="loading == true">
          <div
            v-bind:key="i"
            class="card-femsa d-flex justify-content-center justify-content-md-between flex-row mb-4"
          >
            <div
              class="row justify-content-between align-items-center w-100 row-gap-20"
            >
              <!-- <div
                            class="d-flex justify-content-between align-items-center d-content-full"
                        > -->
              <div
                class="col-6 col-sm-1 checkbox d-flex justify-content-center"
              >
                <div>
                  <b-form-checkbox
                    v-model="item.seleccionado"
                  ></b-form-checkbox>
                </div>
              </div>
              <div class="col-6 col-sm text-center">
                <div for="inputFn" class="card-femsa-titulo mb-4">
                  Pedido Nº
                </div>
                <span id="inputFn" class="card-femsa-sub-titulo">{{
                  item.numeroDocumento
                }}</span>
              </div>
              <div class="col-6 col-sm text-center">
                <div for="inputDateLast" class="card-femsa-titulo mb-4">
                  Fecha Pedido
                </div>
                <span
                  id="inputDateLast"
                  class="text-danger card-femsa-sub-titulo"
                  ><i class="fa fa-times-circle"></i>
                  {{ item.fechaEmision | formatDate }}</span
                >
              </div>
              <div class="col-6 col-sm text-center">
                <div for="inputLocale" class="card-femsa-titulo mb-4">
                  Local
                </div>
                <span id="inputLocale" class="card-femsa-sub-titulo">{{
                  item.sucursal
                }}</span>
              </div>
              <div class="col-6 col-sm text-center">
                <div for="inputMount" class="card-femsa-titulo mb-4">
                  monto total
                </div>
                <span id="inputMount" class="card-femsa-sub-titulo">{{
                  item.monto | currency
                }}</span>
              </div>
              <div class="col-6 col-sm text-center">
                <div for="inputCredited" class="card-femsa-titulo mb-4">
                  abonado
                </div>
                <span id="inputCredited" class="card-femsa-sub-titulo">{{
                  item.abonado | currency
                }}</span>
              </div>
              <div class="col-6 col-sm text-center">
                <div for="inputCredit" class="credit card-femsa-titulo mb-4">
                  Monto a Pagar
                </div>
                <money
                  v-model="item.saldo"
                  v-bind="money"
                  class="badge-femsa badge-azul w-100"
                  disabled
                ></money>
              </div>
            </div>
          </div>
        </template>
      </b-overlay>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import {
  GET_ORDERS_DOCUMENTS_ADMINISTRADOR,
  GET_BALANCES,
} from "@/core/services/store/client.module";
import {
  GET_METHODS,
  CREATE_ORDER_DOCUMENTS,
} from "@/core/services/store/payment.module";

import { Money } from "v-money";
import { validationMixin } from "vuelidate";
import { minLength } from "vuelidate/lib/validators";

import moment from "moment";
moment.locale("es");

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: { Money },
  props: ["rutEmpresa","empresa"],
  data() {
    return {
      page: 1,
      perPage: 9999999999,
      selected: [],
      loading: true,
      menu2: false,
      menu1: false,
      hasta: null,
      desde: null,
      sucursal: "",
      codigoMedioPago: "",
      order: {},
      form: {
        documento: "",

        desde: "",
        hasta: "",
      },
      deudaTotal: 0,
      saldoDisponible: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
      json_fields: {
        Documento: "numeroDocumento",
        Monto: "monto",
        Abonado: "abonado",
        Saldo: "saldo",
        Sucursal: "sucursal",
        Vencimiento: "fechaVencimiento",
      },
    };
  },
  validations: {
    form: {
      documento: {
        minLength: minLength(3),
      },
      desde: {},
      hasta: {},
    },
  },
  mounted() {
    this.onSubmit();
  },
  methods: {
    cancelar() {
      this.selectAll = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        sucursal: null,
        desde: null,
        hasta: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const documento = this.$v.form.documento.$model;
      const sucursal = this.sucursal;
      const desde = this.desde;
      const hasta = this.hasta;
      const rutEmpresa = this.rutEmpresa;

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.getDocuments({
          params: { documento, sucursal, desde, hasta, rutEmpresa },
        });
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    },
    getDocuments(params = null) {
      this.$Progress.start();
      this.$store
        .dispatch(GET_ORDERS_DOCUMENTS_ADMINISTRADOR, params)
        .then((response) => {
          (this.deudaTotal = response.totalDeuda),
            this.$Progress.finish(),
            (this.loading = false);
        });
    },
    getBalances(params = null) {
      this.$Progress.start();
      this.$store
        .dispatch(GET_BALANCES, params)
        .then((response) => {
          (this.saldoDisponible = response.totalSaldoAFavor),
            this.$Progress.finish(),
            (this.loading = false);
        })
        .catch(function () {
          this.$Progress.finish(), (this.loading = false);
        });
    },
    getMethods() {
      this.$Progress.start();
      this.$store.dispatch(GET_METHODS).then(() => {
        this.$Progress.finish();
      });
    },
    getOrder() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const t = this;
      this.$store
        .dispatch(CREATE_ORDER_DOCUMENTS, {
          codigoMedioPago: this.codigoMedioPago,
          Detalles: this.documents,
        })
        .then(function (response) {
          t.order = response;
          t.$router.push({
            name: "confirm-order-pay",
            params: { codigo: response.tokenOrden },
          });
          /*setTimeout(function () {
                        if (t.order.nuevaVentana) {
                            var left = screen.width / 2 - 800 / 2;
                            var top = screen.height / 2 - 600 / 2;
                            window.open(
                                "",
                                "formpopup",
                                "width=800,height=600,resizeable,scrollbars, top=" +
                                    top +
                                    ", left=" +
                                    left
                            );
                            document.getElementById("irapagar").target =
                                "formpopup";
                        }
                        document.getElementById("irapagar").submit();
                    }, 10);*/
        });
    },
    onUpdatePay(activePay) {
      console.log("activePay", activePay);

      this.codigoMedioPago = activePay;
    },
    estiloItem(item) {
      const hoy = new Date();
      var date1 = moment(hoy).format("yyyy-mm-dd");
      var date2 = moment(item.fechaVencimiento).format("yyyy-mm-dd");
      if (moment(date1).isBefore(date2)) {
        return "text-success";
      } else {
        return "text-danger";
      }
    },
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  computed: {
    visiblePages() {
      return this.documents.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
    selectAll: {
      get() {
        if (this.documents && this.documents.length > 0) {
          // A users array exists with at least one item
          let allChecked = true;

          for (const user of this.documents) {
            if (!this.selected.includes(user.id)) {
              allChecked = false; // If even one is not included in array
            }

            // Break out of loop if mismatch already found
            if (!allChecked) break;
          }

          return allChecked;
        }

        return false;
      },
      set(value) {
        const checked = [];
        this.documents.forEach((user) => {
          checked.push(user.id);
          user.seleccionado = value;
        });

        this.selected = checked;
      },
    },
    ...mapState({
      documents: (state) => state.client.documents,
      balances: (state) => state.client.balances,
      sucursales: (state) => state.client.branchs,
      methods: (state) => state.payment.methods,
      errors: (state) => state.errors,
      client: (state) => state.auth.user,
      totalSumm: function () {
        return this.documents
          .filter((item) => item.seleccionado)
          .reduce(function (total, item) {
            return total + item.saldo;
          }, 0);
      },
      totalDeuda: function () {
        return this.documents.reduce(function (total, item) {
          return total + (item.monto - item.abonado);
        }, 0);
      },
      rutCliente: function () {
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },
      computedDateFormattedMomentjs() {
        return this.desde ? moment(this.desde).format("DD/MM/yyyy") : "";
      },
      computedDateFormattedMomentjs2() {
        return this.hasta ? moment(this.hasta).format("DD/MM/yyyy") : "";
      },
    }),
  },
};
</script>
<style>
.custom-checkbox label {
  margin-top: 5px;
  display: block;
}
.custom-control-label::before {
  position: absolute;
  top: 0rem !important;
}
.custom-control-label::after {
  top: 0rem !important;
}
.b-form-datepicker {
  min-width: 130px;
}
.b-form-datepicker label {
  padding-bottom: 3px !important;
  padding-top: 6px;
  text-transform: none;
  white-space: nowrap !important;
  font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  padding: 10px 5px;
}
.d-content-full {
  width: 100%;
}
</style>
